import React from 'react';

export default () => (
  <footer className='container-fluid black_more'>
  <div className='bg-footer'>
    <img src='./img/footer-img.jpg' alt='bg-footer'/>
  </div>
    <div className='row m-10-hor'>
      <div className='col-md-4'>
        <div className='footer-col'>
          <div className='heading'>
            <h2 className='font-weight-bold '>Hakkımızda</h2>
          </div>
          <div className='content'>
             <p>Hangrup olarak, güvenlik sistemleri ve ambalaj çözümleri alanında kaliteli, yenilikçi ve güvenilir hizmet sunmayı hedefliyoruz</p>
          </div>
          <div className='link-call' onClick={()=> window.open("mailto:support@artha.com", "_self")}>info@hangrup.org</div>
        </div>
      </div>
      <div className='col-md-2'>
        <div className='footer-col'>
          <div className='heading'>
            Kolay Linkler
          </div>
          <div className='content'>
             <div className='link'><a href='/about' target='_blank' style={{ color: 'inherit', textDecoration: 'none' }}>Hakkımızda</a></div> 
             <div className='link'> <a href='/contact' target='_blank' style={{ color: 'inherit', textDecoration: 'none' }}>İletişim</a></div>
             <div className='link'><a href='/about' target='_blank' style={{ color: 'inherit', textDecoration: 'none' }}>Vizyonumuz</a></div>  
             <div className='link'><a href='/about' target='_blank' style={{ color: 'inherit', textDecoration: 'none' }}>Misyonumuz</a></div> 
          </div>
        </div>
      </div>

      <div className='col-md-4'>
        <div className='footer-col'>
          <div className='heading'>
            Takip Et
          </div>
          <div className='content'>
            <p>Sosyal Medya Hesaplarımızdan bizi takip edebilirsiniz.</p>
            <div className='socialicon'>
            <span className="shine"></span>
              <i className="fa fa-facebook-f"></i>
            </div>
            <div className='socialicon' onClick={()=> window.open("https://www.instagram.com/hangrupltd/", "_blank")}>
            <span className="shine"></span>
              <i className="fa  fa-instagram"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='subfooter'>
      <div className='row m-10-hor'>
        <div className='col-md-6'>
          <div className='content'> <a href='https://miracsanci.com.tr' target='_blank' rel='noopener noreferrer'><span className='font-weight-bold'>Mirac Sancı tarafından hazırlanmıştır.</span></a>  | © Copyrights 2025 Tüm hakları saklıdır.</div>
        
        </div>
      </div>
    </div>
  </footer>
);
